import Cache from "../DataCache";
import WebSocketManager from "./socket";

class SocketStandard extends WebSocketManager {
  constructor() {
    const deleteCacheCb = () => {
      Cache.delCache("private_message_cache");
      Cache.delCache("im_message_cache");
      Cache.delCache("room_data_cache");
    };

    super(deleteCacheCb);
  }
}

const webSocketInstance = new SocketStandard();

// // mock socket返回数据
// window._mock_socket = (d) => {
//   d.sequence = webSocketInstance.SEQUENCE_RECORD[d.type] ? webSocketInstance.SEQUENCE_RECORD[d.type] + 1 : d.sequence
//   webSocketInstance.webSocketOnMessage({data: JSON.stringify(d)})
// }
export default webSocketInstance;
